<template lang="pug">
md-layout(md-column='')
  // Page content
  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Impersonate', :nav='nav')

    // Form
    md-layout.form-wrapper(:md-gutter='16')
      md-whiteframe.form-wrapper-frame(md-elevation='3')
        h2.md-title(style='flex: 1') Impersonate an Account
        account-selector(v-model='account', :canEdit='true', :hideAccountId='siteuser.user_metadata.account_id')

    md-layout(md-align='center')
      md-button#submit-btn.md-raised.md-primary(v-if='!impersonating' @click='start', md-theme='blue')
        | Impersonate
      md-button#submit-btn.md-raised.md-primary(v-if='impersonating && account' @click='stop', md-theme='blue')
        | Stop Impersonating
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import accountService from '../services/accountService';
  import AccountSelector from '../shared-components/account/AccountSelector';
  import Breadcrumbs from '../shared-components/Breadcrumbs';

  export default {
    components: {
      AccountSelector,
      Breadcrumbs
    },
    data() {
      return {
        account: null,
      };
    },
    methods: {
      start() {
        localStorage.setItem('impersonate', this.account);
        location.href = '/';
      },
      stop() {
        localStorage.removeItem('impersonate');
        location.href = '/';
      }
    },
    computed: {
      ...mapState({
        siteuser: state => state.user.siteuser
      }),
      nav() {
        return [
          { title: 'Impersonate', route: 'Impersonate' },
        ]
      },
      impersonating() {
        return (this.account === localStorage.getItem('impersonate'));
      }
    },
    mounted() {
      if(localStorage.getItem('impersonate')) {
        this.account = localStorage.getItem('impersonate');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .form-wrapper {
    width: 100%;
    padding: 25px 25%;
    .form-wrapper-frame {
      width: 100%;
      padding: 25px;
      margin-bottom: 15px;
      .md-subheading {
        margin-top: 35px;
      }
    }
    @media (max-width: 1200px) {
      padding: 10px .5%;
      margin-left: 0;
    }
  }
  #submit-btn {
    margin: 25px 0;
    width: 33%;
    padding: 6px;
    font-size: 1.1em;
  }
</style>



// WEBPACK FOOTER //
// src/spa/Impersonate.vue